export default __webpack_public_path__ + "static/media/ups.51254039.svg";